// assets/peru.js
// FHL GO – Peru page behaviour (language + calculator)

/* ===================== I18N TEXT ===================== */

const FHL_I18N = {
  en: {
    toggleLabel: "EN | ES",
    crumbHome: "Home",
    crumbPe: "Peru Shipping",
    crumbStores: "Stores",
    
    title1: "Ship to Peru —",
    title2: "Door-to-Door",
    badge1: "🇺🇸 → 🇵🇪 PERU",
    intro:
      "Reliable, streamlined shipping — from any U.S. address to our Miami hub, delivered across Peru.",
    ctaShip:   "Start a shipment",
    ctaCalc:   "Open calculator",
    ctaStores: "Popular US stores",

    howTitle: "How it works",
    s1: "Shop at any US store.",
    s2: "Ship your items to our Miami address or drop them off:",
    copiedLabel:"Copied!",
    s3: "Email your shopping list (links, sizes/colors, quantities).",
    s4: "We consolidate and prepare your shipment.",
    s5: "Door-to-door delivery in Peru.",

    shopView:  "Popular US stores",
    shopEmail: "Email your list",
    whLead:    "Questions? WhatsApp Charo Stewart:",

    lockTitle: "Miami warehouse / locker",
    lockL1:    "Address: 8035 NW 68th St, Miami, FL 33166",
    lockL2:    "Drop-off hours: Mon–Fri 9am–5pm",
    lockL3:    "We’ll notify you when items arrive and can consolidate by request.",

    faqTitle:  "Schedules & transit",
    schedAir:  "Air:",
    airSched:  "Departures every Friday",
    airTransit:"5-7 days in transit",

    sideTitle: "Start shipping",
    sideP:     "Start your door-to-door shipping, hassle-free — create your shipment now.",

    estTitle:  "Estimate your shipment",
    uLb:       "lb/in",
    uKg:       "kg/cm",
    fWeight:   "Weight",
    fValue:    "Declared value (USD)",
    fL:        "Length",
    fW:        "Width",
    fH:        "Height",
    btnCalc:   "Calculate",

    total: "Estimated total",
    insLabel: "Insurance (1% of declared value)",

    estDisclaimer:
      "This is an estimate and may change. Duties, taxes, and certain fees are not included.",

    // fine print paragraphs (HTML allowed)
    fine1:
      "<strong>AirFreight:</strong> $4.25 per lb (chargeable = higher of actual vs volumetric).",
    fine2:
      "<strong>Volumetric weight:</strong> L×W×H ÷ 166 (inches) · L×W×H ÷ 5000 (cm → kg → lb).",
    fine3:
      "<strong>Handling fee:</strong> Cat. 1 = $15 · Cat. 2 = $15 · Cat. 3 = $20.",
    fine4:
      "<strong>Categories by Declared Value:</strong> Cat. 1 = $0 (documents, no taxes) · Cat. 2 = $0.01–$200 (no taxes) · Cat. 3 = $200.01–$2000 (24% on CIF). CIF = Declared Value + Insurance + Freight.",

    followTitle:  "FOLLOW US ON",
    companyTitle: "COMPANY",
    legalTitle:   "LEGAL INFO",
    lnkAbout:     "About Us",
    lnkServices:  "Services",
    lnkBlog:      "Blog",
    lnkTerms:     "Terms of Service",
    lnkPrivacy:   "Privacy Policy",
    lnkRefunds:   "Refund Policy",

    copyright:
      "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",

    // calculator labels
    cat1:  "Category 1 (Documents — no taxes)",
    cat2:  "Category 2 (≤ $200 — no taxes)",
    cat3:  "Category 3 ($200.01–$2000 — 24% CIF)",
    det:   "Detected Category:",
    ch:    "Chargeable Weight",
    vol:   "Volumetric",
    fr:    "Freight",
    hd:    "Handling",
    tx:    "Taxes",
    txna:  "Taxes: N/A (Cat. 1–2)",
    cif:   "CIF",
    total: "Estimated total"
  },

  es: {
    toggleLabel: "ES | EN",
    crumbHome: "Inicio",
    crumbPe: "Envíos a Perú",
    crumbStores: "Tiendas",
    badge1: "🇺🇸 → 🇵🇪 PERÚ",
    title1: "Envíos a Perú —",
    title2: "Puerta a Puerta",
    intro:
      "Envíos confiables y sin complicaciones — desde cualquier parte de EE. UU. a nuestro centro en Miami, entregado a cualquier destino en Perú.",
    ctaShip:   "Crear un envío",
    ctaCalc:   "Abrir calculadora",
    ctaStores: "Tiendas populares",

    howTitle: "Cómo funciona",
    s1: "Compra en cualquier tienda de EE. UU.",
    s2: "Envía tus artículos a nuestra dirección en Miami o entrégalos en persona:",
    copiedLabel:"¡Copiado!",
    s3: "Envíanos tu lista (enlaces, tallas/colores, cantidades).",
    s4: "Consolidamos y preparamos tu envío.",
    s5: "Entrega puerta a puerta en Perú.",

    shopView:  "Tiendas populares de EE. UU.",
    shopEmail: "Envíanos tu lista",
    whLead:    "¿Dudas? WhatsApp Charo Stewart:",

    lockTitle: "Bodega / casillero en Miami",
    lockL1:    "Dirección: 8035 NW 68th St, Miami, FL 33166",
    lockL2:    "Horario: Lun–Vie 9am–5pm",
    lockL3:    "Te avisamos cuando llegue tu compra y podemos consolidar a pedido.",

    faqTitle:  "Salidas y tránsito",
    schedAir:  "Aéreo:",
    airSched:  "Salidas todos los viernes",
    airTransit:"5-7 días en tránsito",

    sideTitle: "Comenzar envío",
    sideP:     "Comienza tu envío puerta a puerta, sin complicaciones — crea tu envío ahora.",

    estTitle:  "Calcula tu envío",
    uLb:       "lb/pulg",
    uKg:       "kg/cm",
    fWeight:   "Peso",
    fValue:    "Valor declarado (USD)",
    fL:        "Largo",
    fW:        "Ancho",
    fH:        "Alto",
    btnCalc:   "Calcular",

    total: "Total estimado",
    insLabel: "Seguro (1% del valor declarado)",

    estDisclaimer:
      "Este es un estimado y puede cambiar. No incluye aranceles, impuestos u otros cargos.",

    fine1:
      "<strong>Flete Aereo:</strong> US$ 4.25 por lb (se cobra el mayor entre peso real y volumétrico).",
    fine2:
      "<strong>Peso volumétrico:</strong> L×W×H ÷ 166 (pulgadas) · L×W×H ÷ 5000 (cm → kg → lb).",
    fine3:
      "<strong>Manejo:</strong> Cat. 1 = US$ 15 · Cat. 2 = US$ 15 · Cat. 3 = US$ 20.",
    fine4:
      "<strong>Categorías por valor declarado:</strong> Cat. 1 = US$ 0 (documentos, sin impuestos) · Cat. 2 = US$ 0.01–US$ 200 (sin impuestos) · Cat. 3 = US$ 200.01–US$ 2000 (24% sobre CIF). CIF = Valor declarado + Seguro + Flete.",

    followTitle:  "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle:   "INFO LEGAL",
    lnkAbout:     "Quiénes somos",
    lnkServices:  "Servicios",
    lnkBlog:      "Blog",
    lnkTerms:     "Términos del servicio",
    lnkPrivacy:   "Política de privacidad",
    lnkRefunds:   "Política de reembolsos",

    copyright:
      "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",

    cat1:  "Categoría 1 (Documentos — sin impuestos)",
    cat2:  "Categoría 2 (≤ US$ 200 — sin impuestos)",
    cat3:  "Categoría 3 (US$ 200.01–US$ 2000 — 24% CIF)",
    det:   "Categoría detectada:",
    ch:    "Peso facturable",
    vol:   "Volumétrico",
    fr:    "Flete",
    hd:    "Trámite aduanal",
    tx:    "Impuestos",
    txna:  "Impuestos: N/A (Cat. 1–2)",
    cif:   "CIF",
    total: "Total estimado"
  }
};

/* ===================== LANGUAGE TOGGLER ===================== */

function fhlApplyLang(langCode) {
  const d = FHL_I18N[langCode] || FHL_I18N.en;

  // Page title
  document.title =
    langCode === "es"
      ? "FHL GO — Envíos a Perú"
      : "FHL GO — Ship to Peru";

  // General elements
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    const val = d[key];
    if (val == null) return;

    // Fine print + other bits can have HTML
    if (val.indexOf("<") !== -1) {
      el.innerHTML = val;
    } else {
      el.textContent = val;
    }
  });

  // Button label
  const langBtn = document.getElementById("lang");
  if (langBtn && d.toggleLabel) {
    langBtn.textContent = d.toggleLabel;
  }

  // Estimator disclaimer text (has its own node)
  const disc = document.querySelector(".est-muted");
  if (disc && d.estDisclaimer) {
    disc.textContent = d.estDisclaimer;
  }

  // Re-translate TOTAL label if a total already exists
  const estTot = document.getElementById("estTotal");
  if (estTot && estTot.dataset.totalValue) {
    estTot.textContent = `${d.total}: $${estTot.dataset.totalValue}`;
  }
}

// init + button hookup
(function initLang() {
  const stored = localStorage.getItem("fhl_lang") || "en";
  fhlApplyLang(stored);

  const btn = document.getElementById("lang");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const current = localStorage.getItem("fhl_lang") || "en";
    const next = current === "en" ? "es" : "en";
    localStorage.setItem("fhl_lang", next);
    fhlApplyLang(next);
    window.dispatchEvent(new Event("fhl_lang_changed"));
  });
})();

/* ===================== CALCULATOR ===================== */

(function peruCalculator() {
  const RATE_PER_LB = 4.25;
  const HANDLING = { 1: 15, 2: 15, 3: 20 };
  const TAX_RATE = 0.24;
  const INS_RATE = 0.01; // 1% insurance over declared value

  const toLb = (kg) => kg * 2.2046226218;
  const cmVolKg = (L, W, H) => (L * W * H) / 5000; // kg
  const inVolLb = (L, W, H) => (L * W * H) / 166;  // lb
  const money = (n) => (Math.round(n * 100) / 100).toFixed(2);
  const currentLang = () => localStorage.getItem("fhl_lang") || "en";

  function detectCategory(val) {
    if (!val || val <= 0) return 1;
    if (val <= 200) return 2;
    return 3;
  }

  const btn = document.getElementById("calcBtn");
  if (!btn) return;

  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const t = FHL_I18N[currentLang()];
    const unitIsLb =
      (document.querySelector('input[name="unitW"]:checked')?.value || "lb") ===
      "lb";

    const w    = parseFloat(document.getElementById("w").value)    || 0;
    const L    = parseFloat(document.getElementById("l").value)    || 0;
    const W    = parseFloat(document.getElementById("w2").value)   || 0;
    const H    = parseFloat(document.getElementById("h").value)    || 0;
    const dec  = parseFloat(document.getElementById("decl").value) || 0;

    const actualLb = unitIsLb ? w : toLb(w);
    let volLb = 0;

    if (L > 0 && W > 0 && H > 0) {
      volLb = unitIsLb ? inVolLb(L, W, H) : toLb(cmVolKg(L, W, H));
    }

    const chargeable = Math.max(actualLb, volLb || 0);

    const cat       = detectCategory(dec);
    const freight   = chargeable * RATE_PER_LB;
    const insurance = dec * INS_RATE;       // 1% of declared value
    const handling  = HANDLING[cat] || 0;
    const cif       = dec + freight + insurance;
    const taxes     = cat === 3 ? cif * TAX_RATE : 0;
    const total     = freight + handling + taxes + insurance;

    const catLabel  = cat === 1 ? t.cat1 : cat === 2 ? t.cat2 : t.cat3;
    const insLabel  = t.insLabel || "Insurance";

    const lines = [
      `${t.det} ${catLabel}`,
      `${t.ch}: ${chargeable.toFixed(2)} lb` +
        (volLb ? ` (${t.vol}: ${volLb.toFixed(2)} lb)` : ""),
      `${t.fr}: $${money(freight)} (US$ 4.25/lb)`,
      `${t.fValue}: $${money(dec)}`,                        // NEW: Declared value line
      `${insLabel}: $${money(insurance)}`,
      `${t.hd}: $${money(handling)}`,
      cat === 3
        ? `${t.tx} (24% ${t.cif} $${money(cif)}): $${money(taxes)}`
        : t.txna,
    ];

    const out = document.getElementById("estOut");
    const tot = document.getElementById("estTotal");
    const box = document.querySelector(".est-result");

    if (out && tot) {
      if (box) box.style.display = "block";
      out.innerHTML = lines.join("<br>");
      const totalStr = money(total);
      tot.textContent = `${t.total}: $${totalStr}`;
      // store numeric total so language toggle can re-label it
      tot.dataset.totalValue = totalStr;
    }

    document.dispatchEvent(new Event("fhl_relayout"));
  });
})();

/* ===================== FOOTER LAYOUT HELPERS ===================== */

// if you still use fhl_relayout / fhl_lang_changed for footer spacing elsewhere
window.addEventListener("fhl_lang_changed", () => {
  document.dispatchEvent(new Event("fhl_relayout"));
});

// ========== Copy Miami address helper ==========
window.copyFHLAddress = function () {
  const icon = document.getElementById("fhlgo-copy-address");
  const confirm = document.getElementById("copy-confirm");
  if (!icon || !confirm) return;

  const text = icon.dataset.address || "8035 NE 68th St, Miami, FL 33166";

  // Try modern clipboard API first
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(
      () => {
        confirm.style.display = "inline";
        setTimeout(() => {
          confirm.style.display = "none";
        }, 1500);
      },
      () => fallbackCopy(text, confirm)
    );
  } else {
    fallbackCopy(text, confirm);
  }
};

function fallbackCopy(text, confirmEl) {
  const temp = document.createElement("textarea");
  temp.value = text;
  temp.style.position = "fixed";
  temp.style.opacity = "0";
  document.body.appendChild(temp);
  temp.select();
  try {
    document.execCommand("copy");
  } catch (e) {}
  document.body.removeChild(temp);

  confirmEl.style.display = "inline";
  setTimeout(() => {
    confirmEl.style.display = "none";
  }, 1500);
}
